<template>
  <div class="app-banner-image">
    <v-container>
      <v-row justify="center" class="app-banner-image__row">
        <v-col cols="10" sm="8" lg="6" class="py-0">
          <v-img
            contain
            :src="require('@/assets/' + image)"
            :alt="alt"
            :max-width="maxWidth"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'BannerImage',
  props: {
    image: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    },
    maxWidth: {
      type: String,
      default: ''
    }
  },
  created() {}
};
</script>

<style lang="scss">
.app-banner-image {
  background-color: var(--v-primary-base);
}
.app-banner-image__row {
  margin: 45px auto;

  @media #{map-get($display-breakpoints, 'md-and-up')} {
    margin: 95px auto;
  }
}
</style>
